import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'transactionLabel', pure: false })
export class TransactionLabelPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  private readonly map: Record<'type', Record<string, string>> = {
    type: {
      'VENDA': 'common.deposit',
      'SAQUE': 'common.withdraw'
    }
  };

  transform(value: string, group: 'type'): string {
    if (!value) return '';
    const keySrc = value.trim().toUpperCase();
    const dictKey = this.map[group][keySrc];
    return dictKey ? this.translate.instant(dictKey) : value;
  }
}
